webpackJsonp([6],{

/***/ "5SxN":
/***/ (function(module, exports) {

module.exports = {
    menu: {
        home: 'Home',
        team: 'Team',
        contact: 'Contact'
    },
    team: [{ post: 'SAN Founder (Principal Partner)', name: 'Yan Yu', introduce: '13 years’ experience in computer graphic industry. Mr. Yu regards SAN as his child, saying that the growth of this company is the same process as his child, it needs time and efforts to build for a successful future.', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }, { post: 'ccc', name: 'dd', introduce: 'xxxxxxxxxx', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }, { post: 'eee', name: 'ff', introduce: 'tttttttttt', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }],
    contact: {
        company: 'CMK',
        phone: 'Phone',
        address: 'Address',
        guide: 'Guide',
        guideDetail: [{ guide: '1.xxxxx' }, { guide: '2.aaaaa' }]
    }
};

/***/ }),

/***/ "8xVf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5ac4bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("zeIl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a5ac4bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__("e6fC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__("qb6w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_masonry__ = __webpack_require__("w/U7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_index_css__ = __webpack_require__("zEeJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__style_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__style_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styles_css__ = __webpack_require__("8xVf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__style_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__style_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_photo_preview__ = __webpack_require__("ibnl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_photo_preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_photo_preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_photo_preview_dist_skin_css__ = __webpack_require__("tOCg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_photo_preview_dist_skin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_photo_preview_dist_skin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_font_awesome_css_font_awesome_min_css__ = __webpack_require__("e0XP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_i18n__ = __webpack_require__("TXmL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_lazyload__ = __webpack_require__("cTzj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_carousel__ = __webpack_require__("/kJX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui__ = __webpack_require__("zL8q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("tvR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_element_ui_lib_theme_chalk_index_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_element_ui___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_carousel___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_lazyload___default.a, { attempt: 1 });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_photo_preview___default.a, { fullscreenEl: false, bgOpacity: 0.7, counterEl: false, zoomEl: false, closeEl: true, showAnimationDuration: 0, useLargeImages: false });
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_masonry__["a" /* VueMasonryPlugin */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_bootstrap_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.imageServer = 'http://www.cmkcg.com/images'; //后台图片服务器地址
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.serverUrl = 'http://www.cmkcg.com:9999'; //后台服务器请求地址

function getLang(name, defaultValue) {
  var lang = navigator.language || navigator.userLanguage;
  if (lang === 'zh-TW') return 'hk';
  if (lang === 'zh-HK') return 'hk';
  return lang.substr(0, 2);
}
var i18n = new __WEBPACK_IMPORTED_MODULE_12_vue_i18n__["a" /* default */]({
  locale: getLang('PLAY_LANG', 'zh'), // 语言标识
  // locale: 'zh',
  messages: {
    'zh': __webpack_require__("NvzY"),
    'en': __webpack_require__("5SxN"),
    'hk': __webpack_require__("Vm03")
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  i18n: i18n,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NvzY":
/***/ (function(module, exports) {

module.exports = {
    menu: {
        home: '首页',
        team: '团队',
        contact: '联系我们'
    },
    team: [{ post: '啊啊啊', name: '嘻嘻嘻', introduce: '打发大幅度', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }, { post: '大订单', name: '发发发', introduce: '分公司分公司覆盖', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }, { post: '额鹅鹅鹅', name: '嘎嘎嘎嘎', introduce: '又要投入托付给', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }],
    contact: {
        company: 'CMK公司',
        phone: '电话',
        address: '地址',
        guide: '乘车路线',
        guideDetail: [{ guide: '1.打算发的111' }, { guide: '2.爱打飞机垃圾的说法了444' }]
    }
};

/***/ }),

/***/ "Vm03":
/***/ (function(module, exports) {

module.exports = {
    menu: {
        home: '首頁',
        team: '團隊',
        contact: '聯繫我們'
    },
    team: [{ post: '啊啊啊', name: '嘻嘻嘻', introduce: '打发大幅度', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }, { post: '大订单', name: '发发发', introduce: '分公司分公司覆盖', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }, { post: '额鹅鹅鹅', name: '嘎嘎嘎嘎', introduce: '又要投入托付给', pic: 'http://img.cheerue.com/41A40353-B98F-0EF1-C0AD-EE9603D77BB7_thinkv_2017-04-28_5902c9a836289.jpg' }],
    contact: {
        company: 'CMK公司',
        phone: '電話',
        address: '地址',
        guide: '乘車線路',
        guideDetail: [{ guide: '1.打算发的111' }, { guide: '2.爱打飞机垃圾的说法了444' }]
    }
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'main',
    component: function component() {
      return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "6+aJ"));
    },
    children: [{
      path: 'cmk',
      component: function component() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "FylU"));
      }
    }, {
      path: 'contact',
      component: function component() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "S4JM"));
      }
    }, {
      path: 'work',
      component: function component() {
        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "JhwZ"));
      }
    }, {
      path: '*',
      component: function component() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "dAjm"));
      }
    }]
  }]
}));

/***/ }),

/***/ "e0XP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qb6w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tOCg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tvR6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zEeJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zeIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d652a383c22c6b4c9987.js